"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveWorkflowReportScope = void 0;
const tools_1 = require("../../tools");
const types_1 = require("../../types");
const utils_1 = require("../utils/utils");
const resolveActivityReportScope_1 = require("./resolveActivityReportScope");
const resolveWorkflowReportScope = (metaExpression, options, logger) => {
    const callStack = new Error().stack;
    logger === null || logger === void 0 ? void 0 : logger.logInfo(`[resolveWorkflowReportScope] called from : ${callStack}`);
    if (metaExpression.scope !== types_1.META_EXPRESSION_SCOPE.WORKFLOW_REPORT)
        throw new tools_1.InternalError("MetaExpression Scope not align.");
    const { workflow, activities, activity_report, get_options_label, scolParams, mxolParams, workflow_report, } = options;
    let activity = undefined;
    let activityReport = activity_report;
    logger === null || logger === void 0 ? void 0 : logger.logInfo(`
     [resolveWorkflowReportScope] Resolving meta expression with options ${JSON.stringify({
        workflow: workflow === null || workflow === void 0 ? void 0 : workflow.id,
        activity_report: activity_report === null || activity_report === void 0 ? void 0 : activity_report._id,
        workflow_report: workflow_report === null || workflow_report === void 0 ? void 0 : workflow_report.id,
        meta_expression_step: metaExpression.step,
        meta_expression_field: metaExpression.field,
    })}
    `);
    if (workflow_report &&
        metaExpression.step == types_1.__ME_STEP_CURRENT_WORKFLOW__ &&
        metaExpression.field) {
        const result = workflow_report[metaExpression.field];
        logger === null || logger === void 0 ? void 0 : logger.logInfo(`[resolveWorkflowReportScope] Found workflow_report field '${metaExpression.field}' with value: ${JSON.stringify(result)}`);
        let formattedResult = result;
        if (typeof formattedResult != "string") {
            formattedResult = JSON.stringify(formattedResult);
        }
        return (0, utils_1.getMeResultFieldResult)(formattedResult);
    }
    if (workflow_report && workflow_report.step_overview && metaExpression.step) {
        // try to get activity report from workflow_report_id, for frontend workflow scope
        const workflowReport = workflow_report;
        const stepFound = workflowReport.step_overview.find((s) => s.step_id == metaExpression.step);
        if (!stepFound)
            return (0, utils_1.getMeResultNoResult)();
        const activityReportFound = stepFound.result && Array.isArray(stepFound.result)
            ? (0, utils_1.convertKeyValuePairsIntoObject)(stepFound.result)
            : {};
        activityReportFound.id = stepFound.activity_report_id;
        activityReport = activityReportFound;
    }
    // validation
    if (!workflow)
        return (0, utils_1.getMeResultNoResult)();
    if (!activityReport) {
        return (0, utils_1.getMeResultNoResult)();
    }
    if (workflow && workflow.steps && activities && metaExpression.step) {
        const step = workflow.steps.find((s) => s.id == metaExpression.step);
        if (!step)
            return (0, utils_1.getMeResultNoResult)();
        activity = activities.find((a) => a.id === step.schema_id);
        if (!activity)
            return (0, utils_1.getMeResultNoResult)();
    }
    return (0, resolveActivityReportScope_1.resolveActivityReportScope)(Object.assign(Object.assign({}, metaExpression), { scope: types_1.META_EXPRESSION_SCOPE.ACTIVITY_REPORT }), {
        activity,
        activity_report: activityReport,
        get_options_label,
        scolParams,
        mxolParams,
    });
};
exports.resolveWorkflowReportScope = resolveWorkflowReportScope;
